import React from "react";
import "./CommentsSection.css";


const ViewComments = ({ comments }) => (
  <div className="comments-list">
    {comments.length > 0 ? (
      comments.map((comment) => (
        <div key={comment.id} className="comment">
          <p>{comment.comment}</p>
        </div>
      ))
    ) : (
      <p className="no-comments">No comments yet.</p>
    )}
  </div>
);

export default ViewComments;




